import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBriefcase, FiArrowRight } = FiIcons;

const CeoPartnerBanner = () => {
  return (
    <section className="bg-gray-950 border-y border-purple-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <motion.a
          href="https://ceo-wanted.appscamelot.com/"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          whileHover={{ y: -2 }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
          className="group flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl border border-white/10 bg-gradient-to-r from-purple-600/20 via-blue-600/20 to-purple-600/20 px-6 py-5 shadow-xl"
        >
          <div className="flex items-center gap-4 text-center sm:text-left">
            <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-white/10 text-purple-200">
              <SafeIcon icon={FiBriefcase} className="w-6 h-6" />
            </span>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-purple-300">
                New Opportunity
              </p>
              <h2 className="mt-1 text-xl font-bold text-white">
                Looking for a CEO Partner
              </h2>
              <p className="mt-1 text-sm text-gray-300">
                Join us and help lead the next stage of MVP72.
              </p>
            </div>
          </div>
          <span className="flex items-center rounded-lg bg-white px-5 py-3 font-semibold text-gray-900 transition-colors group-hover:bg-purple-100">
            View Opportunity
            <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
          </span>
        </motion.a>
      </div>
    </section>
  );
};

export default CeoPartnerBanner;